module.exports = __webpack_public_path__ + "img/SKMA_rubber.1e076fcc.png";